export const visi = [
  {
    content:
      "Menciptakan pengusaha muda yang dibekali pengembangan inovasi dan sustainabilitas dalam bisnis",
  },
  {
    content:
      "Meningkatkan kualitas Universitas Brawijaya dalam membangun atmosfer wirausaha",
  },
  {
    content:
      "Mewadahi mahasiswa dalam mengekspresikan kemampuan wirausaha bersama usaha inovatif mereka",
  },
];

export const misi = [
  {
    content:
      "Menyediakan pemahaman bisnis berbasis inovasi dan sustainabilitas serta bagaimana merealisasikannya",
  },
  {
    content:
      "Melakukan branding terhadap Universitas Brawijaya sebagai World Class Entrepreneurial University",
  },
  {
    content:
      "Mewadahi usaha mahasiswa untuk ditunjukkan dalam kegiatan pameran wirausaha (expo)",
  },
  {
    content:
      "Memberikan kesempatan bagi wirausaha muda untuk berjejaring dengan sesama wirausaha maupun investor",
  },
];

export const filosofi = [
  {
    content:
      "Kuning melambangkan kepribadian entrepreneur yang memiliki jiwa optimis dan sebagai penyemangat serta pemimpin bagi sekitarnya untuk mencapai kesuksesan",
    background: "bg-[#F9D168]",
    text: "text-black",
  },
  {
    content:
      "Biru melambangkan kepercayaan diri dan tanggung jawab yang tinggi merupakan hal yang harus mengarli di setiap daerah entrepreneur",
    background: "bg-[#09102E]",
  },
  {
    content:
      "Jingga melambangkan entrepreneur yang memiliki kreativitas tinggi dan penuh inspirasi melakukan perubahan",
    background: "bg-[#EB623C]",
  },
  {
    content:
      "Hijau membangun konsentrasi yang menjadikan entrepreneur percaya dalam setiap langkah perubahan yang lebih baik",
    background: "bg-[#56BDB1]",
    text: "text-black",
  },
];
